import React from 'react'
import img1 from '../../assets/course/image-1.png'
import img2 from '../../assets/course/image-2.png'
import img3 from '../../assets/course/image-3.png'
import img5 from '../../assets/course/image-4.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Programoffer = () => {
  return (
    <div>
        <div class="coursebox-section ws-section pb-5">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8">
                                <h2 class="ws-section_heading pd-03">Customized Training Programs</h2>
                            </div>
                            <div class="col-lg-4 align-self-center">
                                <a href='/courses'>
                                <button class="btn-primary btn-icon" href="index.html#about">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                            </a>
                            </div>
                        </div>

                        <div class="row align-items-center gx-xl-28 mt-5 dark-bg">
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img1} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/product-category/vlsi-courses-for-freshers/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">Job-oriented VLSI courses</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span></li>
                                        <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-user" /> <span>Divyashree | Prasanth</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img2} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/product-category/vlsi-online-courses/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">Online VLSI courses</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" />
                                        <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span>
                                        </li>
                                        <li class="d-flex align-items-center mb-1"><FontAwesomeIcon icon="fa-solid fa-user" />
                                        <span>Divyashree | Prasanth</span>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img3} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/product-category/vlsi-courses-for-professionals/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">Part-time VLSI courses</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span></li>
                                        <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-user" /> <span>Divyashree | Prasanth</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img5} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/vlsi-internship/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">VLSI Internship</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span></li>
                                        <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-user" /> <span>Divyashree | Prasanth</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
    </div>
  )
}

export default Programoffer